import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom'
import { invertirFecha } from '../tools/utils';
import LoaderFormal from '../tools/LoaderFormal'
import toast from 'react-hot-toast'
import { ProductContext } from '../../context/ProductContext';
import { AuthContext } from '../../context/AuthContext';
import FormPago from './FormPago';
import PagoFracaso from './pagoFracaso/PagoFracaso';
import PagoExitoso from './pagoExitoso/PagoExitoso';

const Pagar = () => {
  const { reserva } = useContext(ProductContext);
  const { usuario } = useContext(AuthContext)
  const [loader, setLoader] = useState(false);
  const [totalMasCuotas, setTotalMasCuotas] = useState(reserva?.totalReserva || '');
  const [numeroReserva, setNumeroReserva] = useState('');
  const [mensajeRespuesta, setMensajeRespuesta] = useState('');
  const [traerModalError, setTraerModalError] = useState(false);
  const [traerModalExito, setTraerModalExito] = useState(false);
  const [tarjetaElegida, setTarjetaElegida] = useState({})
  const [numeroTarjeta, setNumeroTarjeta] = useState(0)
  const [cvv, setCvv] = useState(0)
  const [titularTarjeta, setTitularTarjeta] = useState('')
  const [anioExp, setAnioExp] = useState(0)
  const [mesExp, setMesExp] = useState(0)
  const [tipoDocumento, setTipoDocumento] = useState('')
  const [numeroDocumento, setNumeroDocumento] = useState(0)
  const [bancoSeleccionado, setBancoSeleccionado] = useState(0)
  const [montoTotalPayway, setMontoTotalPayway] = useState(0);
  const [tasa, setTasa] = useState(0);
  const [cantidadCuotas, setCantidadCuotas] = useState({})

  window.scrollTo(0, 0);

  const insertarReserva = (e) => {
    setLoader(true)
    e.preventDefault();
    let medioDePago = e.target.name;
    const sessionId = localStorage.getItem('sessionId');
    const intereses = totalMasCuotas - reserva.totalReserva;
    const prismaIdMap = {
      25: 1,   // visa
      26: 31,  // visa débito
      29: 65,  // amex
      27: 104, // master crédito
      28: 106, // master débito
      30: 8    // diners
    };
    const prismaId = tarjetaElegida.idCuentaEntidad
      ? prismaIdMap[tarjetaElegida.idCuentaEntidad] || null
      : null;
    const nuevaReserva = {
      ...reserva,
      sessionId: sessionId,
      idEntidad: usuario.idEntidadG,
      intereses: intereses,
      cuotas: cantidadCuotas.cuota,
      tasa: tasa,
      bancoSeleccionado: bancoSeleccionado,
      cod_bcom: bancoSeleccionado,
      tarjetaSeleccionada: prismaId,
      datosPago: {
        numeroTarjeta: numeroTarjeta,
        mesExp: mesExp,
        anioExp: anioExp,
        cvv: cvv,
        siglas: tipoDocumento.sigla,
        numeroDocumento: numeroDocumento,
        idtarm: tarjetaElegida.idCuentaEntidad,
        totalPagar: montoTotalPayway,
        nombreTarjeta: tarjetaElegida.descripcion,
        titularTarjeta: titularTarjeta,

      }
    }
    if (
      !medioDePago === 'mp' ||
      nuevaReserva.tarjetaSeleccionada === 0 ||
      nuevaReserva.bancoSeleccionado === 0 ||
      nuevaReserva.datosPago.mesExp === 0 ||
      nuevaReserva.cuotas === null ||
      nuevaReserva.datosPago.anioExp === 0 ||
      nuevaReserva.datosPago.siglas === null ||
      nuevaReserva.datosPago.numeroDocumento === 0 ||
      nuevaReserva.datosPago.totalPagar === 0
    ) {
      toast.error("Debe completar todos los datos del formulario de la tarjeta")
      setLoader(false);
      return;
    }
   

    const url = `https://estanciamargarita.com.ar/backendGama/php/servicios/serviciosReserva.php`;
    const data = { peticion: 30, reserva: nuevaReserva, medioDePago: medioDePago };

    
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: new Headers()
    }).then(res => res.json())
      .catch(error => console.error('Error:', error))
      .then(function (resultado) {
        //{console.log(resultado)}
        if (resultado) {
          if (resultado.estado === 'exito') {
            setTraerModalExito(true);
          } else {

            const [mensajeError, mensajeReserva] = (resultado.mensaje || '').split('---').map(s => s.trim());
            if (mensajeError && mensajeReserva) {
              toast.error(mensajeError);
              toast.error(mensajeReserva);
              setNumeroReserva(mensajeReserva)
              setMensajeRespuesta(mensajeError)
              setTraerModalError(true)
            } else {
              toast.error(resultado.mensaje); // fallback
              setTraerModalError(true)
            }
            setLoader(false);
          }

        } else {
          toast.error("Ha ocurrido un error indefinido:")
          setLoader(false);
        }


        setLoader(false);
      });
  }

  const handlePagoFracaso = () => {
    window.location.replace("https://estanciamargarita.com.ar/auth/profile");
  }

  if (traerModalError) {
    return <PagoFracaso onClick={() => handlePagoFracaso()} reserva={numeroReserva} error={mensajeRespuesta} />
  }
  if (traerModalExito) {
    return <PagoExitoso />
  }

  return (
    <div className="pt-20">

      <div className='bg-gray-200/80 backdrop-blur-3xl md:m-20 p-10 md:rounded-xl'>
        <LoaderFormal loaded={loader} mensaje="Reservando..." />

        <h4 className='font-bebas text-3xl text-center '>Pagar y Reservar</h4>
        <hr />
        <br />


        <div className="">
          {/*<p>Atención: En caso de que no abone su reserva por adelantado nos contactaremos para poder gestionar el cobro dentro de las 24 hs. Las reservas deben abonarse antes del evento para poder ingresar a la Estancia.</p> */}
          <div className=' grid rounded md:rounded-xl' >



            <div className='flex flex-wrap justify-space '>

              <div className="w-full md:w-2/4 px-3 mb-6 md:mb-0 ">
                <div className="bg-zinc-400/20 backdrop-blur-2xl rounded-lg shadow-md ring-1 ring-gray-200 p-6 space-y-6 ">
                  <h2 className="font-bebas text-3xl text-center md:text-left border-b pb-2">Resumen de tu Reserva</h2>

                  <div className="space-y-2">
                    <p className="font-bebas text-xl text-gray-700">Día del Evento:</p>
                    <p className="text-2xl font-bold text-emerald-700">{reserva?.evento.fecha ? invertirFecha(reserva?.evento.fecha) : reserva?.evento.fecha}</p>
                  </div>

                  <div className="space-y-2">
                    <p className="font-bebas text-xl text-gray-700">Total de Personas:</p>
                    <p className="text-2xl font-bold text-emerald-700">{reserva?.paxTotales}</p>
                  </div>

                  <div className="space-y-2">
                    <p className="font-bebas text-xl text-gray-700">Total de la Reserva:</p>
                    
                      <p className="text-2xl font-bold text-emerald-700">${reserva ? totalMasCuotas : reserva.totalReserva}</p>
                
                  </div>

                  <hr className="my-4" />

                  <div className="space-y-2">
                    <p className="text-xl font-bebas text-gray-800">Datos del Contacto:</p>
                    <ul className="text-gray-600 space-y-1 text-sm">
                      <li><strong className="text-gray-800">Titular:</strong> {reserva.titular}</li>
                      <li><strong className="text-gray-800">Email:</strong> {reserva.email}</li>
                      <li><strong className="text-gray-800">Teléfono:</strong> {reserva.telefono}</li>
                    </ul>
                  </div>
                </div>
              </div>


              <div className='w-full md:w-2/4 px-3   rounded-xl md:text-right text-center'>
                <FormPago
                  onClickTotalCuotas={(e) => setTotalMasCuotas(e)}
                  onTarjetaSeleccionada={(e) => setTarjetaElegida(e)}
                  onNumeroTarjeta={(e) => setNumeroTarjeta(e)}
                  onCvv={(e) => setCvv(e)}
                  onTitularTarjeta={(e) => setTitularTarjeta(e)}
                  onAnioExp={(e) => setAnioExp(e)}
                  onMesExp={(e) => setMesExp(e)}
                  onTipoDocumento={(e) => setTipoDocumento(e)}
                  onNumeroDocumento={(e) => setNumeroDocumento(e)}
                  onBancoSeleccionado={(e) => setBancoSeleccionado(e)}
                  onTasa={(e) => setTasa(e)}
                  onCantidadCuotas={(e) => setCantidadCuotas(e)}
                  onMontoTotalPayway={(e)=> setMontoTotalPayway(e)}
                />
              </div>
            </div>
            <div className='p-5 w-full'>
              <Link
                className={` w-full float-center  mb-3 inline-flex h-12 items-center justify-center gap-2 whitespace-nowrap rounded ${loader ? 'bg-gray-400 cursor-not-allowed' : 'bg-emerald-500 hover:bg-emerald-600'} px-6 text-md font-medium tracking-wide text-white transition duration-300  focus:bg-emerald-700 focus-visible:outline-none disabled:cursor-not-allowed disabled:border-emerald-300 disabled:bg-emerald-300 disabled:shadow-none`}
                name="mp" onClick={(e) => {
                  if (loader) {
                    e.preventDefault();
                  } else {
                    insertarReserva(e);
                  }
                }}
              > {loader ? 'Procesando...' : 'PAGAR'}</Link>
            </div>

          </div>

          <Link className="float-center  mb-3 inline-flex h-12 items-center justify-center gap-2 whitespace-nowrap rounded px-6 text-md font-medium tracking-wide text-white hover:text-zinc-200 transition duration-300  focus:bg-emerald-700 focus-visible:outline-none disabled:cursor-not-allowed disabled:border-emerald-300 disabled:bg-emerald-300 disabled:shadow-none bg-zinc-700 hover:bg-zinc-900" to={`/formulario/${reserva.idEvento}`}>Volver</Link>
        </div>
      </div>
    </div>
  );
}

export default Pagar